export default "__VITE_ASSET__021af8b0__"